module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "width": "100%",
      "height": "100%",
      "position": "relative"
    }
  }, [_c('div', {
    staticClass: "login-panel-wrapper-background"
  }, [_vm._v(" \n")]), _vm._v(" "), _c('div', {
    staticClass: "login-panel-wrapper"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "login-panel"
  }, [_c('div', {
    staticClass: "login-header"
  }, [_c('span', {
    staticClass: "login-app-title"
  }, [_vm._v(_vm._s(_vm.appSettings.appName))]), _vm._v(" "), _c('span', {
    staticClass: "login-app-ver"
  }, [_vm._v(_vm._s(_vm.appSettings.appVer))])]), _vm._v(" "), _c('keep-alive', [_c('router-view')], 1)], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "welcome-central-content"
  }, [_c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "login-text-title",
    staticStyle: {
      "line-height": "20px"
    }
  }, [_vm._v("ФК АССОЦИАЦИЯ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-14578224","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Welcome/Welcome.vue
// module id = 387
// module chunks = 0